import { toast } from 'react-toastify';

export const notify = function (obj = {}, options = {}) {
    const message = obj?.response?.data?.message || obj?.response?.data || obj?.message || obj || 'Something went wrong :('
    toast(message, {
        bodyClassName: 'text-danger'
    })
}